export default __webpack_public_path__ + "static/media/PokeApp.01e1f8bf.png";